import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import * as notificationsActions from '../../../../actions/notifications';
import {recordGAEvent} from '../../../../utils/analytics';
import NotificationsView from './NotificationsView';

function NotificationsContainer() {
  const organisation = useSelector(state => state.organisation);
  const dispatch = useDispatch();
  const history = useHistory();
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const buttonRef = React.useRef(null);
  const drawerRef = React.useRef(null);

  function handleNotificationsOuterClick(event) {
    if ((drawerRef.current && drawerRef.current.contains(event.target)) ||
      (buttonRef.current && buttonRef.current.contains(event.target))) {
      return;
    }

    setIsDrawerOpen(false);
    document.removeEventListener('mousedown', handleNotificationsOuterClick, false);
  }

  function hideNotifications() {
    setIsDrawerOpen(false);
    document.removeEventListener('mousedown', handleNotificationsOuterClick, false);
  }

  function handleNotificationClick(action) {
    if (action?.REDIRECT) {
      history.push(action.REDIRECT);
    }

    hideNotifications();
  }

  function showNotifications() {
    setIsDrawerOpen(true);
    dispatch(notificationsActions.updateLastSeenNotifications(organisation.organisationId));
    document.addEventListener('mousedown', handleNotificationsOuterClick, false);
    recordGAEvent('Notifications', 'Open notification drawer');
  }

  function handleNotificationDrawerButtonClick() {
    if (isDrawerOpen) {
      hideNotifications();
    } else {
      showNotifications();
    }
  }

  React.useEffect(() => () => {
    document.removeEventListener('mousedown', handleNotificationsOuterClick, false);
  }, []);

  return (
    <>
      <NotificationsView
        isDrawerOpen={isDrawerOpen}
        buttonRef={buttonRef}
        drawerRef={drawerRef}
        onNotificationDrawerButtonClick={handleNotificationDrawerButtonClick}
        onNotificationClick={handleNotificationClick}
      />
    </>
  );
}

export default NotificationsContainer;
